export default __webpack_public_path__ + "static/media/6.8dc6fc58.png";